import { analysis_reference_area_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateAnalysisReferenceAreaEnum = (enumValue: analysis_reference_area_enum) => {
  switch (enumValue) {
    case analysis_reference_area_enum.BGF:
      return <Trans i18nKey="Enum_AnalysisReferenceAreaEnum-BGF" />;
    case analysis_reference_area_enum.EBF:
      return <Trans i18nKey="Enum_AnalysisReferenceAreaEnum-EBF" />;
    case analysis_reference_area_enum.MF:
      return <Trans i18nKey="Enum_AnalysisReferenceAreaEnum-MF" />;
    case analysis_reference_area_enum.NGF:
      return <Trans i18nKey="Enum_AnalysisReferenceAreaEnum-NGF" />;
  }
};

export const translateAnalysisReferenceAreaEnum_dynamic = (enumValue: analysis_reference_area_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case analysis_reference_area_enum.BGF:
      return t('Enum_AnalysisReferenceAreaEnum-BGF');
    case analysis_reference_area_enum.EBF:
      return t('Enum_AnalysisReferenceAreaEnum-EBF');
    case analysis_reference_area_enum.MF:
      return t('Enum_AnalysisReferenceAreaEnum-MF');
    case analysis_reference_area_enum.NGF:
      return t('Enum_AnalysisReferenceAreaEnum-NGF');
  }
};
